module.exports = __webpack_public_path__ + "static/media/header-img-2.1364d8e2.png";